import { Model } from 'shared/services/api/models/Model'

import { NotepadProductOfferAdditionalInfoDiscountV1 } from './notepadResponseTypes'

export class NotepadProductOfferPriceAdditionalInfoDiscount extends Model {
  public percentage: number

  constructor(src: NotepadProductOfferAdditionalInfoDiscountV1) {
    super(src)
    this.percentage = src.percentage
  }
}
